import type { CleanRenderResult } from '@sorrem-client/types';

/** A Babylon scene on the page that a developer snapshot's clean render can draw (#303). */
export interface CleanRenderSource {
    /** Whether its canvas is on the page right now. */
    isShown(): boolean;
    capture(scale: number): Promise<CleanRenderResult>;
    /** The game's own scene, which fills the page: preferred over any smaller preview also on screen. */
    readonly isPrimary?: boolean;
}

const sources: CleanRenderSource[] = [];

/** Offers `source` to clean renders until the returned function is called. */
export function registerCleanRenderSource(source: CleanRenderSource): () => void {
    sources.push(source);
    return (): void => {
        const index = sources.indexOf(source);
        if (index >= 0) {
            sources.splice(index, 1);
        }
    };
}

/** The scene a clean render draws: the game's when it is shown, else the latest preview shown, else null. */
export function findCleanRenderSource(): CleanRenderSource | null {
    const shown = sources.filter((source) => source.isShown());
    return shown.find((source) => source.isPrimary) ?? shown[shown.length - 1] ?? null;
}
